module.exports = __webpack_public_path__ + "static/img/gh.9e338876.svg";